/**
 * Turn an Inertia error bag into lines a person can read.
 *
 * WHY THIS EXISTS — a real bug, not tidiness. The work-order Show page edits
 * DATES, and the server rejects a timeline that does not hold together
 * ("return to service on cannot be before arrived at shop on") with a 422 and
 * an error bag. Neither the timeline editor nor the details card passed
 * `onError`, so Inertia's default kicked in: the errors landed in page props,
 * nothing rendered them, the spinner stopped, and a REJECTED save looked
 * exactly like a saved one. The operator's correction was simply gone.
 *
 * Rails nests the bag under the form key on an Inertia redirect
 * (`{work_order: {return_to_service_on: [...]}}`) but hands back a flat bag on
 * some paths, and a value can be a single string or an array of them. All four
 * shapes are flattened here so a caller only ever renders `string[]`.
 */
export function errorMessages(errors: unknown): string[] {
  return collect(errors).filter((line) => line.length > 0)
}

function collect(value: unknown): string[] {
  if (value == null) return []
  if (typeof value === "string") return [value.trim()]
  if (Array.isArray(value)) return value.flatMap(collect)
  if (typeof value === "object") {
    return Object.values(value as Record<string, unknown>).flatMap(collect)
  }
  return []
}
